import * as _ from 'lodash';
import { IMicrositeRecipientCompliance } from '@nkr/models/index';
import { TableWrapperLeftAligned } from './styles';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    list: IMicrositeRecipientCompliance[],
    centerId: number
}

const MicrositeCompliance = (props: IProps) => {
    const sortedList = _.sortBy(props.list, x => x.lastName);

    return (
        <div style={{ height: props.list.length < 10 ? null : 300, overflowY: 'auto' }}>
            <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>R#</th>
                        <th>Microsite</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedList.map((item, index) => {
                        let url = `/center/${props.centerId}/microsite/all?msId=${item.id}&mData=1`;

                        return (
                            <tr key={index}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td>
                                    <a href={url} target='_blank'>{item.firstName} {item.lastName}</a>
                                </td>
                                <td>
                                    {item.complianceIssues.map((issue, index) =>
                                        <div key={index}>{ReactHtmlParser(issue)}</div>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </TableWrapperLeftAligned>
        </div>
    );
}

export default MicrositeCompliance;